$(function() {
    var source   = $("#AddToCartModal").html();
    var template = Handlebars.compile(source);

    $('.add-to-cart-modal-trigger a').on('click', function(e){
        e.preventDefault();

        var addId = $(this).closest('.add-to-cart-modal-trigger').attr('data-product-id');
        var parentId = $(this).closest('.add-to-cart-modal-trigger').attr('data-addto-product-id');
        var addSku = $('#productSelect'+parentId).find('option:selected').attr('data-variant-title');

        $.ajax({
            url: $(this).attr('href')+'?view=modal',
            complete: function(response){
                var data = { html:response.responseText };

                $("body").append(template(data));
                timber.cache.$thumbImages = $('.modal .ProductThumbs').find('a.product-single__thumbnail');
                timber.productImageSwitch();

                $('.modal').on('click', function(e){
                    if($(e.target).hasClass('modal')) {
                        e.preventDefault();
                        $('.modal').remove();
                        timber.cache.$thumbImages = $('.ProductThumbs').find('a.product-single__thumbnail');
                        timber.productImageSwitch();
                    }
                });
                $('.close-modal-trigger').on('click', function(e){
                    e.preventDefault();
                    $('.modal').remove();
                    timber.cache.$thumbImages = $('.ProductThumbs').find('a.product-single__thumbnail');
                    timber.productImageSwitch();
                });

                $('.modal #AssociatedProduct').val(addSku);

                jQuery(function($) {
                    if($('.modal .tabs').length > 0){
                        $('.modal .tabs').each(function(){
                            var tabs = $(this);

                            if($('.medium-down--show').css('display') == 'block'){
                                if(tabs.hasClass('ui-tabs')){
                                    tabs.tabs('destroy');
                                }
                            }
                            else{
                                if(!tabs.hasClass('ui-tabs')){
                                    tabs.tabs();
                                }
                            }
                        });

                        $(window).on('resize', function(){
                            $('.modal .tabs').each(function(){
                                var tabs = $(this);

                                if($('.medium-down--show').css('display') == 'block'){
                                    if(tabs.hasClass('ui-tabs')){
                                        tabs.tabs('destroy');
                                    }
                                }
                                else{
                                    if(!tabs.hasClass('ui-tabs')){
                                        tabs.tabs();
                                    }
                                }
                            });
                        });
                    }
                });

                ajaxCart.init({
                    formSelector: '.AddToCartForm',
                    cartContainer: '#CartContainer',
                    addToCartSelector: '.AddToCart',
                    cartCountSelector: '#CartCount',
                    cartCostSelector: '#CartCost',
                    moneyFormat: null
                });

                jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
                    // Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
                    jQuery('.modal').remove();
                    timber.cache.$thumbImages = $('.ProductThumbs').find('a.product-single__thumbnail');
                    timber.productImageSwitch();
                    timber.RightDrawer.open();
                });

                var selectCallback2 = function(variant, selector) {
                    timber.productPage({
                        money_format: "",
                        variant: variant,
                        selector: selector
                    });
                    // BEGIN SWATCHES
                    if (variant) {
console.log(selector);
                    var form = jQuery('#' + selector.domIdPrefix).closest('form');
console.log(form);
console.log(form.attr('id'));
                    for (var i=0,length=variant.options.length; i<length; i++) {
                        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
                        if (radioButton.length) {
                        radioButton.get(0).checked = true;

                        var optionValue = jQuery(radioButton).val();    
                        jQuery(radioButton)
                            .closest('.swatch')
                            .find('.header .selected-value')
                            .html(optionValue);
                        }
                    }
                    jQuery('.modal .product-single__thumbnail-holder.variant').hide();
                    jQuery('.modal .product-single__thumbnail-holder.variant[data-variants*="'+variant.sku+'"]').show();
                    }
                    // END SWATCHES    
                };

                jQuery(function($) {
                    new Shopify.OptionSelectors('productSelect'+addId, {
                    product: modalProductDetails[addId]['product'],
                    onVariantSelected: selectCallback2,
                    enableHistoryState: false
                    });

                    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
                    if(modalProductDetails[addId]['selected'] != "Title"){
                        $('.single-option-selector[data-option="option1" ]').before('<label for="productSelect-option-0">'+modalProductDetails[addId]['selected']+'</label>');
                    }

                    // Hide selectors if we only have 1 variant and its title contains 'Default'.
                    if($('#productSelect'+addId+' option').length <= 1){
                        $('.single-option-selector[data-option="option1" ]').hide();
                    }

                    $('.swatch :radio').change(function() {
                    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                    var optionValue = $(this).val();
                    $(this)
                        .closest('form')
                        .find('.single-option-selector')
                        .eq(optionIndex)
                        .val(optionValue)
                        .trigger('change');
                    });
                });
            }
        });
    });
});